
import { Configuration , RedirectRequest } from "@azure/msal-browser";
import { ADMIN_CONFIGS } from "../../utility/constants/common-constants";

export const msalConfig: Configuration = {
  auth: {
    clientId: ADMIN_CONFIGS.CLIENT_ID || "",
    authority: ADMIN_CONFIGS.AUTHORITY,
    redirectUri: ADMIN_CONFIGS.REDIRECT_URI,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [ADMIN_CONFIGS.SCOPES || ""],
};